import { Page } from "$components/page";
import { Tab, Tabs } from "@material-ui/core";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  linkToDevPatientAddConsultation,
  linkToDevPatientAddInvestigations,
  linkToDevPatientDispensePrescriptions,
  linkToDevPatientHistory,
  linkToDevPatientInsurance,
  linkToDevPatientInvoices,
} from "../../links";

const TabNav: FC<{ patientId: string }> = ({ patientId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Tabs
      value={location.pathname}
      onChange={(_, newValue) => navigate(newValue)}
      variant="fullWidth"
    >
      <Tab value={linkToDevPatientHistory({ id: patientId })} label="History" />
      <Tab
        value={linkToDevPatientInvoices({ id: patientId })}
        label="Invoices"
      />
      <Tab
        value={linkToDevPatientInsurance({ id: patientId })}
        label="Insurance"
      />
    </Tabs>
  );
};
/**
 * Chuck whatever random DX stuff you want here to make testing in acceptance
 * or prod easier - we'll remove this all prior to release 👍
 */
const TestButtons: FC<{ patientId: string }> = ({ patientId }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        padding: 8,
        backgroundColor: "chartreuse",
      }}
    >
      <Link to={linkToDevPatientAddInvestigations({ id: patientId })}>
        Go to Add Investigations
      </Link>
      <Link to={linkToDevPatientDispensePrescriptions({ id: patientId })}>
        Go to Dispense
      </Link>
      <Link to={linkToDevPatientAddConsultation({ id: patientId })}>
        Go to Consultation
      </Link>
    </div>
  );
};

export const PatientOverviewLayout: FC = () => {
  const { patientId } = useParams();
  return (
    <Page>
      <TestButtons patientId={patientId} />
      <TabNav patientId={patientId} />
      <Outlet />
    </Page>
  );
};
